<ng-container *ngIf="!isIE">
	<ac-sticky-table
		[dataArray]="dataArray"
		[defaultSortKey]="'ticker'"
		[infoBubbleMappings]="infoBubbleMappings"
		[stickyColumnIndex]="[0, 1]"
		[columnsAlwaysToShow]="columnsAlwaysToShow"
		[showInfoBubble]="true"
		[showColumnRenderer]="false"
		[searchableColumns]="['Ticker']"
		defaultSortDirection="asc"
	></ac-sticky-table>
</ng-container>
<ng-container *ngIf="isIE">
	<ac-sticky-table-ie
		[dataArray]="dataArray"
		[defaultSortKey]="'ticker'"
		[infoBubbleMappings]="infoBubbleMappings"
		[stickyColumnIndex]="[0, 1]"
		[columnsAlwaysToShow]="columnsAlwaysToShow"
		[searchableColumns]="['Ticker']"
		[showInfoBubble]="true"
		[showColumnRenderer]="false"
	></ac-sticky-table-ie>
</ng-container>
<div class="benchmark-disclaimer text-condensed-14-bold" dcrHTMLKey="BENCHMARK_COMPARISON_DISCLAIMER">
	Performance information is sourced from Morningstar. Past performance does not guarantee future results. For standardized performance, see the "Fund Performance and Fees" tab.
</div>
